import { render, staticRenderFns } from "./Logged.vue?vue&type=template&id=048502ea&"
import script from "./Logged.vue?vue&type=script&lang=js&"
export * from "./Logged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports